module.exports = "https://www.ilove11.top/img/face55.fe7a620f.gif";